import { publicRequest } from "../../../requestMeth";
import { editSupplierOfficeSuccess, supplierOfficeFailure, supplierOfficeStart, supplierOfficeSuccess, supplierFailure, supplierStart, supplierSuccess } from "../../reducers/master/suppliersOfficeRedux"


export const getAllsupplierOffice = async (dispatch, token) => {
  dispatch(supplierStart());
  try {
    const res = await publicRequest.get(`/supplieroffice`, {
      headers: { token: `Bearer ${token}` }
    });
    
    dispatch(supplierSuccess(res.data))
    return res.data
  } catch (error) {
    dispatch(supplierFailure([]));
  }
};


export const assignSupplierOffice = async (dispatch, payload, idcompany, token) => {
  dispatch(supplierOfficeStart());
  try {
    const res = await publicRequest.post(`/supplieroffice/${idcompany}`, payload, {
      headers: { token: `Bearer ${token}` }
    });
    dispatch(supplierOfficeSuccess(res.data));
  } catch (error) {
    dispatch(supplierOfficeFailure(error.response.data));
    throw error.response.data;
  }  
};

export const updateSupplierOffice = async (dispatch, payload, token) => {
  dispatch(supplierOfficeStart());
  try {
    const res = await publicRequest.put(`/supplieroffice`, payload, {
      headers: { token: `Bearer ${token}` }
    });
    return res.data;
  } catch (error) {
    dispatch(supplierOfficeFailure());
    return error.response.data
  }  
};

export const editSupplierOffice = async (dispatch, id, payload, token) => {
    dispatch(supplierOfficeStart());
  try {
      const res = await publicRequest.put(`/supplieroffice/edit/${id}`, payload, {
          headers: { token: `Bearer ${token}` }
      });
      dispatch(editSupplierOfficeSuccess(res.data));
  } catch (error) {
    dispatch(supplierOfficeFailure({}));
    return {error: true, message: "No se pudo modificar la relación proveedor-sucursal. Intentelo nuevamente."};
  }
};